//Libraries
import Vue from "vue";
import Vuex from "vuex";

//Modules
import subcontractor from "./modules/subcontractor";
import tableFilters from "./modules/tableFilters";
import JsaStoreModule from "./modules/JsaStoreModule";

//Use
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
        user: null,
        appLoading: true,

        // This is to toast after a page load
        toastObject: null,

        //These are for working with User Saved Filters
        appliedFilters: {},
        updateFilter: false,
        deleteFilter: false,
        permissions_required: null,

        alerts: [],
    },

    mutations: {
        toast(state, toastObject) {
            state.toastObject = toastObject;
        },

        login(state, user) {
            state.user = user;
        },

        currentJobsite(state, jobsite) {
            state.user.jobsite = jobsite;
        },

        logout(state){
            //Null out the user
            state.user = null;
        },

        appLoading(state){
            //Set the flag
            state.appLoading = false;
        },

        setStates(state, state_list) {
            state.state_list = state_list;
        },

        setPermissionsRequired(state, permissions_required){
            state.permissions_required = permissions_required
        },

        upsertFilter(state, payload) {
            //Setup
            var filter = payload.filter;
            var deleteMode = payload.deleteMode ? payload.deleteMode : false;

            //We either need to update a current filter of add the new one
            var filters = state.user.filters;

            //Helper
            var found = false;

            //Loop through all
            for (var i = filters.length - 1; i >= 0; i--)
            {
                if(parseInt(filters[i].id) === parseInt(filter.id))
                {
                    //Update the filter
                    if(deleteMode)
                    {
                        //Splice it
                        filters.splice(i, 1);
                    }
                    else
                    {
                        //Update the Filter
                        filters[i] = filter;
                    }

                    //Set
                    found = true;
                }
            }

            //IF not found, add it
            if(!found)
            {
                filters.push(filter);
            }

            //Set the filters
            state.user.filters = filters;
        },

        setAppliedFilter(state, payload) {
            //Set the Object
            Vue.set(state.appliedFilters, payload.key, payload.filter);
        },

        setUpdateFilter(state, value) {
            state.updateFilter = value;
        },

        setDeleteFilter(state, value) {
            state.deleteFilter = value;
        },

        setAlerts(state, alerts){
            //Set it
            state.alerts = alerts;
        },

        markAlertRead(state, alert_id){
            //Setup
            let alerts = state.alerts;

            //Loop and Check ALL
            for (var i = alerts.length - 1; i >= 0; i--)
            {
                //Check ID
                if(alerts[i].id == alert_id)
                {
                    alerts.splice(i, 1);
                }
            }

            //Set it
            state.alerts = alerts;
        }
    },

	modules: {
        subcontractor,
        JsaStoreModule,
        tableFilters,
	}
});